// extracted by mini-css-extract-plugin
export default {"benefit":"Benefits_benefit__50nrI","title":"Benefits_title__yAGie","dark":"Benefits_dark__gsi+5"};